export default class StockOrders {
    static products (selector)
    {
        if(!$('#addStockOrderCard', selector).length)
            return false;

        const $addButton = $('#addProductBtn', selector), $productSearchApi = $('#searchProducts', selector)[0].selectize, $productRepeaterContainer = $('[data-repeater-list="products"]'), $productRepeaterTemplate = $productRepeaterContainer.find('[data-repeater-item]').first(),
            $supplierSelect = $('.productSupplier select', $productRepeaterTemplate), supplierSrc = $supplierSelect.attr('data-src'), $productInput = $('input[name*="product_id"]', $productRepeaterTemplate);

        $productSearchApi.on('item_add', function (value, $item){
            if(isNaN(value))
                $supplierSelect.removeAttr('data-src');
            else {

                /** Items' supplier select */
                $productInput.val(value);
                $supplierSelect.attr('data-src', supplierSrc.replace('999', value));
                $('.productName', $productRepeaterTemplate).text($item.text());
            }
        });

        $addButton.on('click', function () {
            $supplierSelect.attr('data-src', supplierSrc);
            $productSearchApi.clear();
        });

        $('.stockOrderProductRepeaterItem').each(function () {
            StockOrders.suppliers($(this));
        })

    }

    static suppliers (selector) {

        /** Only use if for stock order product repeater item */
        if(!$(selector).is('.stockOrderProductRepeaterItem'))
            return false;

        let $supplierSelect = $('.productSupplier select', selector), supplierApi = $supplierSelect[0].selectize,
            $supplierRepeater = $('#suppliers'), supplerRepeaterApi = $supplierRepeater[0].repeater, $supplierRepeaterTemplate = supplerRepeaterApi.getTemplate(),
            $supplerRepeaterContainer = $('[data-repeater-list="suppliers"]', $supplierRepeater), $productRepeaterContainer = $('[data-repeater-list="products"]')

        const updateSuppliers = function () {
            /** Find product supplier ids for product repeater items, map to id, filter and then remove duplicates */
            let productSupplierIds = [...new Set($productRepeaterContainer.find('[data-repeater-item]:not(:first-child) [name*=supplier_id]').map( function () {return this.value}).filter(function(key, value) {
                return value; }))];

            /** Find supplier ids for supplier repeater items, map to id, filter and then remove duplicates */
            let supplierIds = [...new Set($supplerRepeaterContainer.find('[data-repeater-item]:not(:first-child) [name*=supplier_id]').map( function () {return this.value}).filter(function(key, value) {
                return value; }))];

            /** Find new supplier ids */
            let newSupplierIds = productSupplierIds.filter(function (value, key) {
                return !supplierIds.includes(value)
            });

            /** Find old supplier ids to be removed */
            let oldSupplierIds = supplierIds.filter(function (value, key) {
                return !productSupplierIds.includes(value)
            });


            /** Add to suppliers */
            for(let [key, value] of Object.entries(newSupplierIds)) {

                let option = supplierApi.options[value];

                $('.supplierName', $supplierRepeaterTemplate).text(option.name)
                $('[name*="supplier_id"]', $supplierRepeaterTemplate).val(option.id)
                $('.supplierEmail input', $supplierRepeaterTemplate).val(option.email)

                supplerRepeaterApi.addItem()
            }

            /** Remove old to suppliers */
            if(oldSupplierIds) {
                /** Find any supplier repeater item which is no longer used */
                $('[data-repeater-item]:not(:first-child) input[name*="supplier_id"]', $supplerRepeaterContainer).filter( function (key, el) {
                    return oldSupplierIds.includes($(el).val())
                }).parents('[data-repeater-item]').remove();
            }
        }


        /** On supplier change */
        $supplierSelect.on('change', function () {
            updateSuppliers();
        })

        /** On repeater row removal */
        $('#products').on('row:deleting', function (event, row){
            updateSuppliers();
        });

    }
}
